// @flow
import React, { type Node } from 'react';

import { Title } from 'Components/frameworks/title/Title.jsx';
import { type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { cardHeadingThemes } from './CardHeading.themes';

export type CardHeadingProps = {
  className?: string,
  color?: Colors,
  hLevel?: number,
  iconName?: IconName,
  small?: Node,
  subtitle?: Node,
  title?: Node,
  theme?: string,
};

export function CardHeading(props: CardHeadingProps) {
  if (!props.title) return null;

  const {
    className,
    color,
    hLevel = 2,
    iconName,
    small,
    subtitle,
    theme = 'default',
    title,
  } = props;
  const { thSmall, thSubtitle, thSubtitleTheme, thTitle, thTitleTheme } = cardHeadingThemes[theme];

  return (
    <div className={className}>
      <Title
        className={thTitle}
        color={color}
        hLevel={hLevel}
        iconName={iconName}
        theme={thTitleTheme}
      >
        {title}
        {!!small && <small className={thSmall}>{small}</small>}
      </Title>
      {!!subtitle && (
        <Title
          hLevel={hLevel < 6 ? hLevel + 1 : 6}
          className={thSubtitle}
          color={color}
          theme={thSubtitleTheme}
        >
          {subtitle}
        </Title>
      )}
    </div>
  );
}
